import { Component, OnInit } from '@angular/core';
import { AccountService } from '../services/account.service';
import { SettingService } from '../services/setting.service';
import { Router } from '@angular/router';
import { LocalStorageServiceEncrypt } from 'angular-2-local-storage-encrypt';
import { NgbModal, NgbNavChangeEvent } from '@ng-bootstrap/ng-bootstrap';
import { RegisterModel } from '../models/registerModel';
import { LogInModel } from '../models/logInModel';
import { TierService } from '../services/tier.service';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss']
})
export class LoginComponent implements OnInit {
  active=1;
  userData: string;
  isVerified = false;
  mobileExist = false;
  resend: boolean;
  otp: string="";
  resendTimer=0;
  interval;
  tabIndexFlag=false;
  register=false;
  registerModel: RegisterModel= new RegisterModel();
  logInModel: LogInModel= new LogInModel();
  namePattern:string=".*[^A-Z a-z ء-ي].*";
  constructor(
    public accountService: AccountService,
    public settingService: SettingService,
    public router: Router,
    private _localStorageService:LocalStorageServiceEncrypt,
    private modalService:NgbModal,
  ) {}


  ngOnInit() {
    this.settingService.loading = false;
    this.settingService.isError = false;
    this.isVerified = false;
    this.resend = false;
    this.settingService.isError = false;
    this.accountService.signOut();
    this.modalService.dismissAll();
  }

  onNavChanged(changeEvent: NgbNavChangeEvent){
    this.settingService.isError = false;
    this.settingService.message = null;
  }
  keyPress(event: any) {
    const pattern = /[0-9\+\-\ ]/;
    let inputChar = String.fromCharCode(event.charCode);
    if (event.keyCode != 8 && !pattern.test(inputChar)) {
      event.preventDefault();
    }
  }

  validateMobileNumber(mobileNumber: string) {
    this.isVerified = false;
    this.resend = false;
    this.settingService.isError = false;
    this.settingService.message = '';
    this.settingService.loading = true;
    this.accountService.validateMobileNumber(mobileNumber).subscribe(res => {
      this.userData = mobileNumber;
      this.settingService.loading = false;
      this.settingService.isError = false;
      this.isVerified = true;
      this.resendTimer= +res.otpTimer;
      this.startTimer();
    },error =>{
      this.settingService.loading = false;
      this.settingService.isError =true;
      this.settingService.message = error.error.message;
    });
  }
  verifyOtp() {
    if(this.otp.length<6)
    {
      return;
    }
    this.settingService.loading = true;
    this.settingService.isError = false;
    this.settingService.message = '';
    this.accountService.verifyOtp(this.userData, this.otp).subscribe(res => {
      localStorage.Registertoken = res.token;
      clearInterval(this.interval);
      this.settingService.loading = false;
      this.register=true;
    },error =>{
      this.isVerified = true;
      this.settingService.loading = false;
      this.settingService.isError =true;
      this.settingService.message = error.error.message;
    });
  }
  createAccount()
  {
    this.settingService.loading = true;
    this.settingService.isError = false;
    this.settingService.message = '';
    this.registerModel.mobileNumber=this.userData;
    this.registerModel.token=localStorage.Registertoken;
    this.accountService.createAccount(this.registerModel).subscribe(res => {
      this.settingService.loading = false;
      this.settingService.isError = false;
      //localStorage.Registertoken = res;
     // localStorage.token = res;
      this.isVerified = false;
      this.mobileExist = false;
      this.register=false;
      this.active=1;
      this.accountService.signOut();
      this.router.navigate(['/login']);
    },error => {
      this.settingService.loading = false;
      this.settingService.isError = true;
      this.settingService.message=error.error.message;
    });
  }

  onOtpChange(event){
    this.otp=event;
  }
  startTimer() {
    this.interval = setInterval(() => {
      if(this.resendTimer==1)
      {
        clearInterval(this.interval);
        this.resend = true;
      }
      this.resendTimer--;
    },1000)
  }

  logIn(numberInvalid,passwordInvalid)
  {
    if(numberInvalid||passwordInvalid)
    {
      return;
    }
    this.settingService.isError = false;
    this.settingService.loading = true;
    this.accountService.logIn(this.logInModel).subscribe(res => {
      if (res.token) {
        localStorage.token = res.token;
        localStorage.Registertoken=res.registerToken;
        this.userData = this.logInModel.mobileNumber;
        this.settingService.getUserInfoFromToken(res.token);
        // this.tierService.getWalletSammary(this.logInModel.userName).subscribe(res=>{
        //   localStorage.walletId=res.walletId;
        //   this.settingService.setWalletSummary(res);
  
        // });
        this.settingService.loading = false;
        this.settingService.isError = false;
        this.accountService.checkDisclaimer(this.logInModel.mobileNumber,false).subscribe(a=>{
          this._localStorageService.set('AcceptTerms',a);
          this.settingService.setAcceptTerms(a);
        });
        this.router.navigate(['home']);
      } else {
        this.settingService.loading = false;
        this.settingService.isError = true;
        this.settingService.message = res.message;
      }
    },error=>{
      this.settingService.loading = false;
      this.settingService.isError = true;
      this.settingService.message=error.error.message;
    });
  }

  keyInputPress(event: any) {
    const pattern = /.*[^A-Z a-z ء-ي].*/;
    let inputChar = String.fromCharCode(event.charCode);
    if (event.keyCode != 8 && pattern.test(inputChar)) {
      event.preventDefault();
    }
  }
  //#endregion
}
